/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { InjectedIntl } from 'react-intl';

/**
 * Localization context to save the react-intl library data such as locale, defineMessage, ... and so on.
 */
export const LocalizationContext = React.createContext<InjectedIntl>(null);
